/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

import $ from "./app/jquery-shim";

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {
  }

  growApp.prototype.enterAnimation = function () {
    let $mainVisual = $('.c-main-visual');
    if (!$mainVisual.length === 0) {
      return false;
    }

    function changeClass(el, className, time) {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          el.addClass(className);
          resolve(className);
        }, time);
      });
    }

    let $smallText =$('.c-main-visual__text');
    let $titleText =$('.c-main-visual__title');
    let $scrollBar =$('.c-main-visual__scroll');
    let $newsBox = $('.c-news-sm');

    var loaderFunction = function () {
      // ここから実行
      if ($mainVisual) {
        changeClass($smallText, "is-active", 1000).then(function () {
          changeClass($titleText, "is-active", 800).then(function () {
            changeClass($scrollBar, "is-active", 800).then(function () {
              changeClass($newsBox, "is-active", 900).then(function () {
              });
            });
          });
        });
      }
    };

    // first entry only
    if (!sessionStorage.getItem('loading')) {
      sessionStorage.setItem('loading', true);
      loaderFunction();
    } else {
      $mainVisual.addClass('is-already');
    }
  };

  growApp.prototype.drawCount = function () {
    let $targetInput = $('.c-block-drawing__table table tbody tr td.is-sm');
    let $submit = $('.c-block-drawing__floating-button');
    let $countText = $('.js-draw-count').text('0');
    let $checkText = $('.js-draw-text');
    $targetInput.on('change', function (){
      let $counter = $targetInput.find('input:checked').length;
      if ($targetInput.find('input:checked').length >= 6) {
        $submit.addClass('is-hidden');
        $checkText.text("上限を超えています");
      } else {
        $submit.removeClass('is-hidden');
        $checkText.text("チェックした図面をダウンロードする");
      }
      $countText.text($counter);
    });
  }

  growApp.prototype.slidebarAccordion = function () {
    let $target = $('.c-slidebar-menu__parent');
    let win = $(window).innerWidth();
    if (win < 750) {
      return false;
    }

    if ($target.hasClass('js-accordion')){
      $target.removeClass('js-accordion');
      $target.find('span').data("accordion-title","menu-title");
      $target.find('ul').removeData();
      console.log('gogo');
    }
  }

  growApp.prototype.relationControl = function () {
    let $target = $('.js-relation-menu');

    if ($target.find('div').length < 5){
      $target.toggleClass('is-center');
    }
  }

  $(function () {
    var app = new growApp();
    app.myCode();
    app.enterAnimation();
    app.drawCount();
    // app.slidebarAccordion();
    app.relationControl();
  });
})(jQuery);
